import { useCreditStore } from "../stores/creditStore";
import { CreditInformationResponse, CreditType } from "../api/types";

interface UseCreditDataReturn {
  creditInfo: Record<CreditType, CreditInformationResponse | null>;
  isLoading: boolean;
  error: string | null;
  refreshPositions: (creditTypes: CreditType[]) => Promise<void>;
}

export function useCreditData(): UseCreditDataReturn {
  const creditInfo = useCreditStore((state) => state.creditInfo);
  const isLoading = useCreditStore((state) => state.isLoading);
  const error = useCreditStore((state) => state.error);
  const refreshPositions = useCreditStore((state) => state._refreshPositions);

  return {
    creditInfo,
    isLoading,
    error,
    refreshPositions,
  };
}
